
<template>
    <div>
        <b-row>
            <b-col cols="12">
                <ValidationObserver ref="uploadForm">
                    <b-row>
                        <b-col cols="12">
                            <ValidationProvider name="file" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="file" :state="errors[0] ? false : null"
                                                     :placeholder="$t('select_file')" ref="fileInput"></b-form-file>
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </b-col>
            <b-col cols="12">
                <processing-button :processing="formStart" variant="primary"
                                   :label="$t('upload')"
                                   @click="uploadFile" />
            </b-col>
        </b-row>
    </div>
</template>
<script>

import ProcessingButton from "@/components/elements/ProcessingButton.vue"
import LmsHomeWorkEntryService from "@/services/LmsHomeWorkEntryService"

export default {
    components: {
        ProcessingButton
    },
    props: {
        formId: {
            type: Number
        },
        userData: {
            type: Object
        }
    },
    data() {
        return {
            file: null,
            formStart: false,
        }
    },

    created() {

    },

    methods: {
        async uploadFile() {
            const isValid = await this.$refs.uploadForm.validate();
            if (isValid) {
                this.formStart = true
                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('lms_homework_id', this.formId)
                LmsHomeWorkEntryService.uploadHomework(formData, this.formId).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                    this.$emit('homeworkSuccess',true)
                }).catch(e => {
                    this.showErrors(e, this.$refs.uploadForm)
                }).finally(() => {
                    this.formStart = false
                })
            }
        }
    }

};
</script>
